import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { FIELDS, MODE } from "../../../constants/SiteConstants";
import Loader from "../../../components/commonComponent/Loader";
import CompanyForm from "./CompanyForm";

const API_URL = process.env.REACT_APP_API_URL;

const fields = [
  { label: "Title", name: "title", placeholder: "Enter Title", required: true },
  {
    label: FIELDS.SLUG,
    name: "slug",
    placeholder: "Enter Slug",
    required: true,
  },
  {
    label: "Brief Description",
    name: "briefDescription",
    placeholder: "Enter brief description",
    required: true,
  },
  {
    label: "Description",
    name: "description",
    placeholder: "Enter description",
    type: "rich-text",
    required: true,
  },
  {
    label: "Image",
    name: "images",
    placeholder: "Choose Image",
    type: "file",
  }
];

const EditCompany = () => {
  const { id } = useParams();
  const [initialData, setInitialData] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const loadDoctorData = async () => {
        try {
          const response = await axios.get(
            `${API_URL}/company/getCompanyById/${id}`
          );
          setInitialData(response.data.data);
          setImagePreview(response.data.data.images);
        } catch (error) {}
      };
      loadDoctorData();
    }
  }, [id]);

  const handleSubmit = async (formData) => {
    try {
      await axios.put(`${API_URL}/company/updateCompanyById/${id}`, formData);
      toast.success("Data updated successfully", {
        autoClose: 1000,
      });
      navigate("/companyManagement");
    } catch (error) {
      toast.error("Error updating data", {
        autoClose: 1000,
      });
    }
  };

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Update Brand
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/companyManagement")}
        >
          &times;
        </button>
      </div>
      {initialData ? (
        <CompanyForm
          mode={MODE.UPDATE}
          onSubmit={handleSubmit}
          fields={fields}
          imagePreview={imagePreview}
          initialData={initialData}
        />
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default EditCompany;
